﻿window.cBuilderEmailWidgetReseau = function (option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetreseau'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Réseaux sociaux</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter des liens sur vos réseaux sociaux")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetreseau'>")
        $("<!-- DEBUT RESEAUX SOCIAUX -->").appendTo(option.element)
        var $Td = $("<td style='width:100%;' width='100%' class='tdwidget bodywidget widgetheightauto' widthicone='30' espacement='5'>").appendTo(option.element)
        $Td.attr("jsoncssdatawidget", JSON.stringify({}))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        mGenereTableauIcone([lstReseau[0], lstReseau[1], lstReseau[2]], $Td)

        $("<!-- FIN RESEAUX SOCIAUX -->").appendTo(option.element)
    }

    function mGenereTableauIcone(lstEleData, contentElement) {
        var widthLeft = "50%"
        var widthRight = "50%"
        switch (option.parent.mGetTextAlignCss()) {
            case "left":
                widthLeft = "0"
                widthRight = "100%"
                break;
            case "center": break;
            case "right":
                widthLeft = "100%"
                widthRight = "0"
                break;
        }

        if (typeof contentElement == 'undefined') contentElement = option.parent.mGetContenuWidget()
        contentElement.empty()
        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablewidget tablelstreseau'>").appendTo(contentElement)
        var $TrTableBt = $("<tr/>").appendTo($Table)
        var $Td = $("<td class='' style='width:" + widthLeft + "'></td>").appendTo($TrTableBt)
        lstEleData.forEach(function (data) { mGenereTdICone(data, lstEleData.length).appendTo($TrTableBt) })
        var $Td = $("<td class='' style='width:" + widthRight + "'></td>").appendTo($TrTableBt)
    }
    function mGenereTdICone(dataReseau, nb) {
        //if (typeof contentElement == 'undefined') contentElement = option.parent.mGetContenuWidget()
        var padding = "padding:0 " + option.parent.mGetBodyWidget().attr("espacement") + "px;"
        var widthIcone = option.parent.mGetBodyWidget().attr("widthicone")
        var maxWidth = 100/nb
        var $TdMaitre = $("<td style='width:" + widthIcone + "px;max-width:" + maxWidth + "%;" + padding + "text-align:center;' class='iconereseau' type='" + dataReseau.type + "'/>")
        var $A = $("<a href='" + dataReseau.url + "' target='_blank' style='display:inline-block;'/>").appendTo($TdMaitre)
        var $TableIcone = $("<table border='0' cellspacing='0' cellpadding='0' style='width: " + widthIcone + "px'>").appendTo($A)
        var $Tr = $("<tr/>").appendTo($TableIcone)
        var $Td = $("<td/>").appendTo($Tr)
        var $img = $("<img src='" + dataReseau.urlImage + "' width='" + widthIcone + "' alt='" + dataReseau.nom + "' style='border-width:0;width: " + widthIcone + "px;'>").appendTo($Td)
        return $TdMaitre
    }
    function mGetElement(urlImage, Nom, type) {
        if (typeof contentElement == 'undefined') contentElement = option.parent.mGetContenuWidget()
        var padding = "padding:0 " + option.parent.mGetBodyWidget().attr("espacement") + "px;"
        var widthIcone = option.parent.mGetBodyWidget().attr("widthicone")
        var $TdMaitre = $("<td style='width:" + widthIcone + "px;" + padding + "text-align:center;' class='iconereseau' type='" + type + "'/>")
        var $A = $("<a href='' target='_blank'/>").appendTo($TdMaitre)
        var $TableIcone = $("<table border='0' cellspacing='0' cellpadding='0' style='width: " + widthIcone + "px'>").appendTo($A)
        var $Tr = $("<tr/>").appendTo($TableIcone)
        var $Td = $("<td/>").appendTo($Tr)
        var $img = $("<img src='" + urlImage + "' width='" + widthIcone + "' alt='' style='border-width:0;width: " + widthIcone + "px;'>").appendTo($Td)
        return $TdMaitre
    }

    function mGetLstElement() {
        var lst = []
        option.parent.mGetContenuWidget().find(".iconereseau").each(function (idx, ele) {
            lst.push({
                url: $(ele).find("a").attr("href"),
                type: $(ele).attr("type"),
                urlImage: $($(ele).find("img")[0]).attr("src"),
                element: $(ele)
            })
        })
        return lst
    }

    function mGetTdLeft() { return $(option.element.find(".tdleft")[0]) }

    this.nom = "Réseaux sociaux"
    this.icone = "fas fa-square-share-nodes"

    var lstReseau = [
        { url: "https://facebook.com", nom: "Facebook", type: "facebook", urlImage: parametre.urldispatch + "/img/social/square-facebook.png" },
        { url: "https://youtube.com", nom: "YouTube", type: "youtube", urlImage: parametre.urldispatch + "/img/social/square-youtube.png" },
        { url: "https://threads.net", nom: "Threads", type: "threads", urlImage: parametre.urldispatch + "/img/social/square-threads.png" },
        { url: "https://instagram.com", nom: "Instagram", type: "instagram", urlImage: parametre.urldispatch + "/img/social/square-instagram.png" },
        { url: "https://pinterest.com", nom: "Pinterest", type: "pinterest", urlImage: parametre.urldispatch + "/img/social/square-pinterest.png" },
        { url: "https://linkedin.com", nom: "Linkedin", type: "linkedin", urlImage: parametre.urldispatch + "/img/social/linkedin.png" },
        { url: "https://tiktok.com", nom: "TikTok", type: "tiktok", urlImage: parametre.urldispatch + "/img/social/tiktok.png" },
        { url: "https://vimeo.com", nom: "Vimeo", type: "vimeo", urlImage: parametre.urldispatch + "/img/social/square-vimeo.png" },
        { url: "https://snapchat.com", nom: "Snapchat", type: "snapchat", urlImage: parametre.urldispatch + "/img/social/square-snapchat.png" },
        { url: "https://x.com", type: "x", nom: "X", urlImage: parametre.urldispatch + "/img/social/square-x-twitter.png" },
        { url: "https://", nom: "Site web", type: "web", urlImage: parametre.urldispatch + "/img/social/square-dribbble.png" },
        { url: "", nom: "Email", type: "mail", urlImage: parametre.urldispatch + "/img/social/square-envelope-solid.png" },
    ]
    var imgPictureDefault = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z'/></svg>"

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()
        //$("<br/>").appendTo(contentElement)

        var lstElement = mGetLstElement()
        var $Table = $("<table/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Réseaux sociaux</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-plus",
            colorIcone: theme.backgroundcolorAccent,
            onClick: function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    width: 200,
                    position: "bottom",
                    target: e.component.element(),
                    contentTemplate: function (contentElement) {
                        contentElement.css("text-align", "left")
                        contentElement.css("font-size", "120%")
                        contentElement.css("padding", "20px")
                        contentElement.css("background-color", theme.backgroundColorTitle)
                        var $Table = $("<table/>").appendTo(contentElement)
                        lstReseau.forEach(function (itemData) {
                            var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                            $Tr.on("click", function (e) {
                                lstElement.push({
                                    url: itemData.url,
                                    type: itemData.type,
                                    urlImage: itemData.urlImage,
                                    element: mGenereTdICone(itemData)
                                })
                                mGenereTableauIcone(lstElement)
                                option.onValueChanged()
                                dxList.reload()
                                tt.hide()
                            })
                            var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                            $("<img src='" + itemData.urlImage + "' style='width:30px;'>").appendTo($Td)
                            var $Td = $("<td style='width:100%'>" + itemData.nom + "</td>").appendTo($Tr)
                        })
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        })
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-certificate",
            colorIcone: theme.backgroundcolorAccent,
            onClick: function (e) {
                lstElement.push({
                    url: "",
                    type: "divers",
                    urlImage: parametre.urldispatch + "/img/social/square-regular.png",
                    element: mGetElement(parametre.urldispatch + "/img/social/square-regular.png", "divers", "")
                })
                mGenereTableauIcone(lstElement)
                option.onValueChanged()
                dxList.reload()
            }
        })

        var dxList = $("<div/>").appendTo(contentElement).dxList({
            dataSource: lstElement,
            itemDragging: {
                allowReordering: true
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding-right", "3px")
                itemElement.css("padding-left", "3px")
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;padding-right:5px;' class='state-hover'/>").appendTo($Tr)
                var $Img = $("<img src='" + itemData.urlImage + "' style='width:30px;'>").appendTo($Td)
                $Img.on("click", function (e) {
                    var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                        bddCtrl: option.bddCtrl,
                        icone: true,
                        imgPexel: true,
                        docCpt: false,
                        courrier: false,
                        multiple: false,
                        accept: ".png,.jpg,.jpeg,.gif,.bmp",
                        onValide: function (lstUrlFile) {
                            if (lstUrlFile.length > 0) {
                                var url = lstUrlFile[0]
                                $("<div/>").appendTo("body").dxCtrlPopupResizeImage({
                                    bddCtrl: option.bddCtrl,
                                    value: url,
                                    onValidation: function (url) {
                                        itemData.urlImage = url
                                        $Img.attr("src", itemData.urlImage)
                                        itemData.element.find("img").attr("src", itemData.urlImage)
                                        mGenereTableauIcone(lstElement)
                                        option.onValueChanged()
                                    }
                                })
                                //option.bddCtrl.mAjaxCall({
                                //    command: "migrein72dpiforemail",
                                //    urlimage: lstUrlFile[0]
                                //}, function (data) {
                                //    itemData.urlImage = lstUrlFile[0]
                                //    $Img.attr("src", itemData.urlImage)
                                //    itemData.element.find("img").attr("src", itemData.urlImage)
                                //    mGenereTableauIcone(lstElement)
                                //    option.onValueChanged()
                                //})
                            }
                            pop.hide();
                        },
                        optionImgInternet: {
                            bddCtrl: option.bddCtrl
                        },
                        optionFileUploader: {
                            bddCtrl: option.bddCtrl
                        }
                    }).dxCtrlFileUploaderPopup("instance")
                })
                var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: ((itemData.type == "mail") ? "Adresse email" : "Adresse web..."),
                    value: itemData.url,
                    onValueChanged: function (e) {
                        itemData.url = ((e.value == null) ? "" : e.value)
                        itemData.element.find("a").attr("href", itemData.url)
                        mGenereTableauIcone(lstElement)
                        option.onValueChanged()
                    }
                })
                var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    onClick: function (e) {
                        lstElement.splice(lstElement.indexOf(itemData), 1)
                        mGenereTableauIcone(lstElement)
                        option.onValueChanged()
                        dxList.reload()
                    }
                })
            },
            onItemReordered: function (e) {
                lstElement.move(e.fromIndex, e.toIndex)
                mGenereTableauIcone(lstElement)
                option.onValueChanged()
            }
        }).dxList("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Taille icone:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlRadioButton({
            dataSource: ["Petit", "Moyen", "Grand", "..."],
            value: ((option.parent.mGetBodyWidget().attr("widthicone") == 20) ? "Petit" : ((option.parent.mGetBodyWidget().attr("widthicone") == 25) ? "Moyen" : ((option.parent.mGetBodyWidget().attr("widthicone") == 30) ? "Grand" : "..."))),
            layout: 'horizontal',
            onValueChanged: function (e) {
                $DivTaille.css("display", "none")
                switch (e.value) {
                    case "Petit":
                        option.parent.mGetBodyWidget().attr("widthicone", "20")
                        dxLargeur.option("value", 20)
                        break;
                    case "Moyen":
                        option.parent.mGetBodyWidget().attr("widthicone", "25")
                        dxLargeur.option("value", 25)
                        break;
                    case "Grand":
                        option.parent.mGetBodyWidget().attr("widthicone", "30")
                        dxLargeur.option("value", 30)
                        break;
                    case "...":
                        $DivTaille.css("display", "");
                        dxLargeur.repaint()
                        break;
                }
                option.onValueChanged()
            }
        })
        var $DivTaille = $("<div style=''/>").appendTo(contentElement)
        switch (option.parent.mGetBodyWidget().attr("widthicone")) {
            case "20": case "25": case "30":
                $DivTaille.hide()
                break;
            default:
                break;
        }
        $("<div style='width:1px;white-space:nowrap;font-size:100%;font-weight:bold;' class=''>Taille</div>").appendTo($DivTaille)
        var dxLargeur = $("<div/>").appendTo($DivTaille).dxSlider({
            min: 15,
            max: 40,
            value: parseInt(option.parent.mGetBodyWidget().attr("widthicone")),
            onValueChanged: function (e) {
                option.parent.mGetBodyWidget().attr("widthicone", e.value)
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}px`;
                },
                showMode: 'always',
                position: 'bottom',
            }
        }).dxSlider("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Espacement:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxSlider({
            min: 0,
            max: 10,
            value: option.parent.mGetBodyWidget().attr("espacement"),
            onValueChanged: function (e) {
                option.parent.mGetBodyWidget().attr("espacement", e.value)
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}px`;
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) {
                window.setTimeout(function () { e.component.repaint() }, 0)
            }
        }).dxSlider("instance")
    }

    this.mRemoveStyle = function () {

    }

    this.mUpdateCss = function () {
        mGenereTableauIcone(mGetLstElement())
    }

}